import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var Events = function Events() {
  var _this = this;

  _classCallCheck(this, Events);

  _defineProperty(this, "on", function (callback) {
    if (typeof callback === 'function') {
      _this.listeners.push(callback);
    }
  });

  _defineProperty(this, "off", function (callback) {
    var index = _this.listeners.indexOf(callback);

    if (index >= 0) {
      _this.listeners.splice(index, 1);
    }
  });

  _defineProperty(this, "fire", function (data) {
    _this.listeners.forEach(function (listener) {
      return listener(data);
    });
  });

  this.listeners = [];
};

export { Events as default };
//# sourceMappingURL=events.js.map